import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatLetterHead as creatLetterHeadApi,
    updateLetterHead as updateLetterHeadApi,
    getAllLetterHead as getAllLetterHeadApi,
    getLetterHead as getLetterHeadApi,
    getSelectedLetterHead as getSelectedLetterHeadApi,
} from './api';

// actions
import { letterHeadApiResponseSuccess, letterHeadApiResponseError } from './actions';

// constants
import { LetterHeadActionTypes } from './constants';

type LetterHeadData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Letter Head
 * @param {*} payload
 */
function* AddLetterHead({ payload, type }: LetterHeadData): SagaIterator {
    try {
        const response = yield call(creatLetterHeadApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                letterHeadApiResponseSuccess(LetterHeadActionTypes.ADD_LETTER_HEAD, data, message, code, false, true)
            );
        } else {
            let msg = `An error while getting Letter Head!`;
            if (message) msg = message;
            yield put(
                letterHeadApiResponseSuccess(LetterHeadActionTypes.ADD_LETTER_HEAD, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(letterHeadApiResponseError(LetterHeadActionTypes.ADD_LETTER_HEAD, [], error, 404, true, false));
    }
}

/**
 * Edit Letter Head
 * @param {*} payload
 */
function* EditLetterHead({ payload, type }: LetterHeadData): SagaIterator {
    try {
        const response = yield call(updateLetterHeadApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                letterHeadApiResponseSuccess(
                    LetterHeadActionTypes.EDIT_LETTER_HEAD,
                    data,
                    'Letter Head Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Letter Head!`;
            if (message) msg = message;
            yield put(
                letterHeadApiResponseSuccess(LetterHeadActionTypes.EDIT_LETTER_HEAD, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(letterHeadApiResponseSuccess(LetterHeadActionTypes.EDIT_LETTER_HEAD, [], error, 404, true, false));
    }
}

/**
 * Fetch Letter Head
 * @param {*} payload
 */
function* GetLetterHead({ payload, type }: LetterHeadData): SagaIterator {
    try {
        const response = yield call(getLetterHeadApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                letterHeadApiResponseSuccess(LetterHeadActionTypes.GET_LETTER_HEAD, data, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Letter Head!`;
            if (message) msg = message;
            yield put(
                letterHeadApiResponseSuccess(LetterHeadActionTypes.GET_LETTER_HEAD, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(letterHeadApiResponseSuccess(LetterHeadActionTypes.GET_LETTER_HEAD, [], error, 404, true, false));
    }
}

/**
 * Fetch Selected Letter Head
 * @param {*} payload
 */
function* GetSelectedLetterHead({ payload, type }: LetterHeadData): SagaIterator {
    try {
        const response = yield call(getSelectedLetterHeadApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                letterHeadApiResponseSuccess(
                    LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Letter Head!`;
            if (message) msg = message;
            yield put(
                letterHeadApiResponseSuccess(
                    LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD,
                    data,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(
            letterHeadApiResponseSuccess(LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD, [], error, 404, true, false)
        );
    }
}

/**
 * Fetch Letter Heads
 * @param {*} payload
 */
function* GetLetterHeads({ payload, type }: LetterHeadData): SagaIterator {
    try {
        const response = yield call(getAllLetterHeadApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                letterHeadApiResponseSuccess(
                    LetterHeadActionTypes.GET_LETTER_HEADS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Letter Head Listing!`;
            if (message) msg = message;
            yield put(
                letterHeadApiResponseSuccess(
                    LetterHeadActionTypes.GET_LETTER_HEADS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(letterHeadApiResponseSuccess(LetterHeadActionTypes.GET_LETTER_HEADS, [], error, 404, true, false));
    }
}

export function* watchGetLetterHead() {
    yield takeEvery(LetterHeadActionTypes.GET_LETTER_HEAD, GetLetterHead);
}

export function* watchGetSelectedLetterHead() {
    yield takeEvery(LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD, GetSelectedLetterHead);
}

export function* watchGetLetterHeads() {
    yield takeEvery(LetterHeadActionTypes.GET_LETTER_HEADS, GetLetterHeads);
}

export function* watchAddLetterHead() {
    yield takeEvery(LetterHeadActionTypes.ADD_LETTER_HEAD, AddLetterHead);
}

export function* watchEditLetterHead(): any {
    yield takeEvery(LetterHeadActionTypes.EDIT_LETTER_HEAD, EditLetterHead);
}

function* letterHeadSaga() {
    yield all([
        fork(watchGetLetterHead),
        fork(watchGetSelectedLetterHead),
        fork(watchAddLetterHead),
        fork(watchEditLetterHead),
        fork(watchGetLetterHeads),
    ]);
}

export default letterHeadSaga;
